module.exports = __webpack_public_path__ + "img/navController-agenda-on.7e09f410.png";